module.exports = __webpack_public_path__ + "img/15.d685d4f3.jpg";